<template>
  <v-btn
    :id="derivedId"
    type="button"
    :size="size"
    class="control-group--button"
    :class="{ 'is-active': isActive }"
    :title="title"
    :icon="icon"
    :variant="isActive ? 'tonal' : 'text'"
  >
  </v-btn>
</template>

<script>
export default {
  name: 'TipTapToolbarButton',

  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    }
  },

  computed: {
    derivedId() {
      const lowercaseTitle = this.title.toLowerCase();
      const kebabCaseTitle = lowercaseTitle.replace(/ /g, '-');
      return `content-editor-tip-tap--${kebabCaseTitle}-btn`;
    }
  }
};
</script>

<style lang="scss" scoped>
.control-group--button {
  border-radius: 0.25rem;
}
</style>
